import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Menu, MenuItem, ListItemIcon, Icon, ListItemText, styled } from "@material-ui/core";
import { isAccessDenied } from "@ploy-lib/rest-resources";
import { OverlayCircularProgress } from "@ploy-ui/core";
import { defineMessages, useIntl } from "react-intl";
import { useAppActionClick } from "../hooks/useAppActionClick";
import { useAppLoad } from "../appLoadContext";
import { BaseCamelCasedResource } from "@ploy-lib/rest-resources";
import { legacyApiResourceUrl } from "@ploy-lib/core";
import { useStatefulResource } from "@rest-hooks/legacy";
import { NetworkError } from "@ploy-lib/types";
class FunctionButtonResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.icon = "";
        this.label = "";
        this.name = "";
        this.shouldRefresh = false;
        this.shouldSave = false;
        this.successMessage = "";
        this.canResend = false;
        this.buttonUrl = "";
        this.disableValidation = false;
    }
    pk() {
        return `${this.name}`;
    }
    static async fetch(input, init) {
        const data = await super.fetch(input, init);
        if (isAccessDenied(data))
            throw new NetworkError({
                status: 403,
                statusText: "AccessDenied"
            });
        return (data.map?.(d => ({ ...d, buttonUrl: d.url })) ?? {
            ...data,
            buttonUrl: data.url
        });
    }
    static detail() {
        const endpoint = super.detail();
        return endpoint.extend({
            schema: this,
            fetch: async (params) => {
                const data = await endpoint.fetch({
                    includedFunctonButtons: params.name
                });
                return data?.[0];
            }
        });
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            dataExpiryLength: 0
        };
    }
}
FunctionButtonResource.urlRoot = legacyApiResourceUrl("AppChange/GetFunctionButtons");
export { FunctionButtonResource };
export const StyledIcon = styled(Icon)({
    overflow: "initial"
});
const DarkOverlayCircularProgress = styled(OverlayCircularProgress)({
    backgroundColor: "rgba(0, 0, 0, 0.3)"
});
export const messages = defineMessages({
    lblCancelWarningApplication: {
        id: "dploy.template-form.app-action.cancel.confirm",
        description: "Label for cancel application alert",
        defaultMessage: "Er du sikker på at du vil bortfalle saken?"
    }
});
const AppAction = forwardRef((props, ref) => {
    const { button } = props;
    const intl = useIntl();
    const { pending, disabled, onClickButton } = useAppActionClick(props);
    return (_jsxs(_Fragment, { children: [pending && _jsx(DarkOverlayCircularProgress, { pending: true }), _jsxs(MenuItem, { button: true, ref: ref, onClick: event => {
                    if (button.name === "Cancel") {
                        if (window.confirm(intl.formatMessage(messages.lblCancelWarningApplication)))
                            onClickButton(event);
                    }
                    else {
                        onClickButton(event);
                    }
                }, disabled: disabled, children: [_jsx(ListItemIcon, { children: _jsx(StyledIcon, { className: button.icon }) }), _jsx(ListItemText, { primary: button.label })] })] }));
});
export const AppActions = (props) => {
    const { anchor, setAnchor, form } = props;
    const appLoad = useAppLoad();
    const { data: buttons, error } = useStatefulResource(FunctionButtonResource.list(), appLoad.id ? {} : null);
    if (error?.status === 403) {
        return null;
    }
    return (_jsx(Menu, { elevation: 0, id: "AppActions-menu", anchorEl: anchor, keepMounted: true, open: Boolean(anchor), onClose: () => setAnchor(null), children: (buttons || []).map(button => (_jsx(AppAction, { form: form, onClose: () => setAnchor(null), button: button }, button.name))) }));
};
AppActions.displayName = "DployAppActions";
export default AppActions;
//# sourceMappingURL=AppActions.js.map